import { useEffect } from "react";
import { stores } from "../stores/rootStore";
import "./about.css";
import vk from "./img/vk.png";
import instagram from "./img/inst.png";

export const About = () => {
  useEffect(() => {
    stores.helpUIStore.setTitle("о нас");
    stores.helpUIStore.setHistory(["about"]);
  }, []);
  return (
    <div className="about_wrapper">
      <div className="about_foto"></div>
      <div className="about_info">
        <div className="about_item">
          <div>
            <div>ул. ​Верхняя Набережная, 145/11 </div>
            <div> 10.00 - 20.00</div>
            <div>+7 (952) 614-38-88</div>
          </div>
        </div>

        <div className="about_contacts">
          <a
            href="https://vk.com/club226331760"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="about_contact_item">
              <img src={vk} alt="Вконтакте" />
            </div>
          </a>

          <a
            href="https://www.instagram.com/cvetochnaya_lavka_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="about_contact_item">
              <img src={instagram} alt="Instagram" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
